export { default as ContentfulButton } from './contentfulButton'



// WEBPACK FOOTER //
// ./src/components/contentful/button/index.js